// Extract module from topic value (e.g., "states_of_matter" doesn't have prefix, need mapping)
// We'll use the topics structure from QuestionFilter.vue

export const moduleMapping = {
    M1: [
        'states_of_matter', 'homogeneous_mixtures', 'heterogeneous_mixtures',
        'basic_separation', 'advanced_separation', 'mass_composition',
        'ionic_naming', 'covalent_naming', 'protons_neutrons_electrons',
        'nuclear_stability', 'radioisotope_applications', 'bohr_shells',
        'quantum_subshells', 'aufbau_pauli_hunds', 'flame_tests',
        'emission_lines', 'valency_trends', 'electronegativity_trends',
        'ionisation_energy', 'atomic_radii', 'electron_affinity',
        'reactivity_trends', 'periodic_table_trends', 'lewis_structures',
        'molecular_geometry', 'dipole_moments', 'h_bonding',
        'dipole_interactions', 'dispersion_forces', 'ionic_lattices',
        'covalent_lattices', 'sea_of_electrons'
    ],
    M2: [
        'balancing_reactions', 'mole_concept', 'avogadro_constant',
        'molar_mass', 'formula_derivation', 'mass_mass_stoichiometry',
        'limiting_reactants', 'yield_calculations', 'atom_economy',
        'concentration_molarity', 'wv_percentage', 'ppm_calculations',
        'dilutions', 'primary_standards', 'combining_volumes',
        'pv_law', 'vt_law', 'vn_law', 'pv_nrt', 'stp_slc_volumes'
    ],
    M3: [
        'synthesis', 'thermal_decomposition', 'electrolytic_decomposition',
        'complete_combustion', 'incomplete_combustion', 'solubility_rules',
        'spectator_ions', 'metal_acid_reactions', 'metal_water_reactions',
        'activity_series', 'redox_definitions', 'oxidation_states',
        'half_equations', 'anodic_oxidation', 'cathodic_reduction',
        'ion_migration', 'standard_potentials', 'collision_theory',
        'surface_area_rate', 'concentration_rate', 'temperature_rate',
        'catalyst_effect'
    ],
    M4: [
        'thermodynamic_systems', 'enthalpy_definition', 'heat_capacity',
        'heat_of_solution', 'heat_of_combustion', 'enthalpy_per_mole',
        'hess_law', 'bond_energy_sum', 'standard_enthalpy_formation',
        'entropy', 'entropy_gas_evolution', 'gibbs_free_energy',
        'reaction_spontaneity', 'temperature_dependent_spontaneity'
    ],
    M5: [
        'open_closed_systems', 'reversibility', 'dynamic_equilibrium',
        'lcp_concentration', 'lcp_pressure', 'lcp_temperature',
        'ea_equilibrium', 'equilibrium_constant', 'reaction_quotient',
        'ice_table', 'solubility_product', 'solubility_calculations',
        'common_ion_effect', 'aboriginal_leaching'
    ],
    M6: [
        'ph_indicators', 'naming_acids', 'arrhenius', 'bronsted_lowry',
        'conjugates', 'amphiprotic_species', 'log_ph', 'kw_water_ionisation',
        'complete_dissociation', 'partial_dissociation', 'acid_base_constants',
        'pka_pkb', 'heat_of_neutralisation', 'titration_equipment',
        'titration_graphs', 'equivalence_points', 'buffers'
    ],
    M7: [
        'organic_naming', 'isomers', 'hydrocarbon_trends', 'alkane_reactions',
        'alkene_reactions', 'alcohol_properties', 'alcohol_combustion',
        'dehydration', 'organic_oxidation', 'fermentation',
        'organic_acid_properties', 'esterification', 'organic_nitrogen_properties',
        'saponification_micelles', 'addition_polymers', 'condensation_polymers'
    ],
    M8: [
        'flame_tests', 'cation_wet_tests', 'anion_wet_tests', 'uv_vis',
        'aas', 'mass_spec', 'ir', 'h_nmr', 'c13_nmr', 'spin_spin_coupling',
        'combined_spectral_analysis', 'synthesis_yield_purity',
        'reaction_pathways', 'green_chem_design'
    ]
};

export const topicLabels = {
    // Module 1
    'states_of_matter': 'State Changes',
    'homogeneous_mixtures': 'Homogeneous Mixtures',
    'heterogeneous_mixtures': 'Heterogeneous Mixtures',
    'basic_separation': 'Filtration & Evaporation',
    'advanced_separation': 'Distillation & Fractionation',
    'mass_composition': 'Percentage Composition',
    'ionic_naming': 'Nomenclature (Ionic)',
    'covalent_naming': 'Nomenclature (Covalent)',
    'protons_neutrons_electrons': 'Atomic Notation',
    'nuclear_stability': 'Isotope Stability',
    'radioisotope_applications': 'Radioisotope Uses',
    'bohr_shells': 'Bohr Shell Model',
    'quantum_subshells': 'Quantum Mechanics',
    'aufbau_pauli_hunds': 'Orbital Filling',
    'flame_tests': 'Flame Testing',
    'emission_lines': 'Emission Spectra',
    'valency_trends': 'Periodic Valency',
    'electronegativity_trends': 'Electronegativity',
    'ionisation_energy': 'Ionisation Energy',
    'atomic_radii': 'Atomic Radius',
    'electron_affinity': 'Electron Affinity',
    'reactivity_trends': 'Metallic Character',
    'periodic_table_trends': 'Periodic Table Trends',
    'lewis_structures': 'Lewis Dot Diagrams',
    'molecular_geometry': 'VSEPR Molecular Shapes',
    'dipole_moments': 'Dipole Moments',
    'h_bonding': 'Hydrogen Bonding',
    'dipole_interactions': 'Dipole-Dipole Forces',
    'dispersion_forces': 'Dispersion Forces',
    'ionic_lattices': 'Ionic Networks',
    'covalent_lattices': 'Covalent Networks',
    'sea_of_electrons': 'Metallic Structure',
    
    // Module 2
    'balancing_reactions': 'Balancing Reactions',
    'mole_concept': 'Mole Concept',
    'avogadro_constant': 'Avogadro Constant',
    'molar_mass': 'Molar Mass',
    'formula_derivation': 'Empirical vs Molecular',
    'mass_mass_stoichiometry': 'Stoichiometric Ratios',
    'limiting_reactants': 'Limiting Reagents',
    'yield_calculations': 'Percent Yield',
    'atom_economy': 'Percent Atom Economy',
    'concentration_molarity': 'Molarity Formulas',
    'wv_percentage': 'Weight/Volume Percent',
    'ppm_calculations': 'Parts Per Million',
    'dilutions': 'Dilution Equation',
    'primary_standards': 'Standard Solutions',
    'combining_volumes': 'Gay-Lussac Gasses',
    'pv_law': "Boyle's Law",
    'vt_law': "Charles' Law",
    'vn_law': 'Avogadro Gas Law',
    'pv_nrt': 'Ideal Gas Law',
    'stp_slc_volumes': 'Molar Volume Gas',
    
    // Module 3
    'synthesis': 'Synthesis Reaction',
    'thermal_decomposition': 'Decomposition (Thermal)',
    'electrolytic_decomposition': 'Decomposition (Electrolytic)',
    'complete_combustion': 'Combustion (Complete)',
    'incomplete_combustion': 'Combustion (Incomplete)',
    'solubility_rules': 'Solubility Rules',
    'spectator_ions': 'Net Ionic Equations',
    'metal_acid_reactions': 'Metal-Acid Reactions',
    'metal_water_reactions': 'Metal-Water Reactions',
    'activity_series': 'Activity Series',
    'redox_definitions': 'Oxidation-Reduction Def',
    'oxidation_states': 'Oxidation Numbers',
    'half_equations': 'Half Equations',
    'anodic_oxidation': 'Galvanic Cell Anode',
    'cathodic_reduction': 'Galvanic Cell Cathode',
    'ion_migration': 'Salt Bridge Function',
    'standard_potentials': 'Standard Potentials',
    'collision_theory': 'Collision Theory',
    'surface_area_rate': 'Surface Area Effect',
    'concentration_rate': 'Concentration Effect',
    'temperature_rate': 'Temperature Effect',
    'catalyst_effect': 'Catalyst Effect',
    
    // Module 4
    'thermodynamic_systems': 'System & Surroundings',
    'enthalpy_definition': 'Enthalpy',
    'heat_capacity': 'Specific Heat Capacity',
    'heat_of_solution': 'Calorimetry (Dissolution)',
    'heat_of_combustion': 'Calorimetry (Combustion)',
    'enthalpy_per_mole': 'Molar Enthalpy Calc',
    'hess_law': 'Hess Law',
    'bond_energy_sum': 'Bond Energy Sums',
    'standard_enthalpy_formation': 'Formation Enthalpy',
    'entropy': 'Entropy Definition',
    'entropy_gas_evolution': 'Entropy Gas Evolution',
    'gibbs_free_energy': 'Gibbs Free Energy',
    'reaction_spontaneity': 'Spontaneity Prediction',
    'temperature_dependent_spontaneity': 'Temperature Spontaneity',
    
    // Module 5
    'open_closed_systems': 'Open vs Closed Systems',
    'reversibility': 'Reversibility',
    'dynamic_equilibrium': 'Dynamic Equilibrium State',
    'lcp_concentration': 'LCP (Concentration)',
    'lcp_pressure': 'LCP (Pressure/Volume)',
    'lcp_temperature': 'LCP (Temperature)',
    'ea_equilibrium': 'Activation Energy Equilibrium',
    'equilibrium_constant': 'Equilibrium Constant',
    'reaction_quotient': 'Reaction Quotient Q',
    'ice_table': 'ICE Table Calc',
    'solubility_product': 'Solubility Product Ksp',
    'solubility_calculations': 'Molar Solubility',
    'common_ion_effect': 'Common Ion Effect',
    'aboriginal_leaching': 'Aboriginal Leaching',
    
    // Module 6
    'ph_indicators': 'Indicator Ranges',
    'naming_acids': 'Nomenclature (Acids)',
    'arrhenius': 'Arrhenius Model',
    'bronsted_lowry': 'Bronsted-Lowry Model',
    'conjugates': 'Conjugate Acid-Base',
    'amphiprotic_species': 'Amphiprotic Nature',
    'log_ph': 'pH Scale & pOH',
    'kw_water_ionisation': 'Kw Water Ionisation',
    'complete_dissociation': 'Strong Acids/Bases',
    'partial_dissociation': 'Weak Acids/Bases',
    'acid_base_constants': 'Ka/Kb Constants',
    'pka_pkb': 'pKa/pKb Relation',
    'heat_of_neutralisation': 'Neutralisation Enthalpy',
    'titration_equipment': 'Titration Equipment',
    'titration_graphs': 'Titration Curves pH',
    'equivalence_points': 'Equivalence Points',
    'buffers': 'Buffers',
    
    // Module 7
    'organic_naming': 'IUPAC Naming Rules',
    'isomers': 'Structural Isomers',
    'hydrocarbon_trends': 'Hydrocarbon Properties',
    'alkane_reactions': 'Alkanes Substitution',
    'alkene_reactions': 'Alkenes Addition',
    'alcohol_properties': 'Alcohol Physical Properties',
    'alcohol_combustion': 'Alcohol Combustion',
    'dehydration': 'Alcohol Dehydration',
    'organic_oxidation': 'Alcohol Oxidation',
    'fermentation': 'Fermentation Ethanol',
    'organic_acid_properties': 'Carboxylic Acids Properties',
    'esterification': 'Esters Preparation',
    'organic_nitrogen_properties': 'Amines/Amides Properties',
    'saponification_micelles': 'Soaps & Detergents',
    'addition_polymers': 'Addition Polymers',
    'condensation_polymers': 'Condensation Polymers',
    
    // Module 8
    'cation_wet_tests': 'Cation Precipitation',
    'anion_wet_tests': 'Anion Analysis',
    'uv_vis': 'UV-Vis Spectroscopy',
    'aas': 'Atomic Absorption (AAS)',
    'mass_spec': 'Mass Spectrometry Frags',
    'ir': 'IR Spectroscopy Bonding',
    'h_nmr': 'NMR Proton Shift',
    'c13_nmr': 'NMR Carbon Shift',
    'spin_spin_coupling': 'NMR Splitting Patterns',
    'combined_spectral_analysis': 'Structural Deduction',
    'synthesis_yield_purity': 'Chemical Synthesis Goals',
    'reaction_pathways': 'Reaction Pathways',
    'green_chem_design': 'Green Chemistry Principles'
};

export function getModuleForTopic(topic) {
    for (const [module, topics] of Object.entries(moduleMapping)) {
        if (topics.includes(topic)) {
            return module;
        }
    }
    return 'Unknown';
}

export function getTopicLabel(topic) {
    return topicLabels[topic] || topic;
}